//authorsTableData.js
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import { fetchApiData } from "../../../features/account/accountthunk";
import { fetchAccountGetData } from "../../../features/accountGet/accountthunk";

export default function useAccountsTableData() {
  const dispatch = useDispatch();

  const [selectedAccount, setSelectedAccount] = useState(null);
  const [filterRole, setFilterRole] = useState("All");
  const [orgName, setOrgName] = useState("");

  // ✅ Get account data from Redux store
  const { data: accountData, loading } = useSelector((state) => state.apiGetData);

  // ✅ Render Avatar helper
  const renderAvatar = (avatar, name) => {
    const firstLetter = (name || "").charAt(0).toUpperCase();
    return avatar ? (
      <MDAvatar src={avatar} name={name} size="sm" variant="rounded" />
    ) : (
      <MDAvatar size="sm" variant="rounded" sx={{ bgcolor: "#1398DC", color: "#fff" }}>
        {firstLetter || "?"}
      </MDAvatar>
    );
  };

 
  const rows = useMemo(() => {
    if (!accountData?.accounts) return [];

    return Object.values(accountData.accounts).map((item) => {
      const acc = item.account || {};
      const guardians = acc.extra?.guardians || [];
      const name = [acc.firstName, acc.lastName].filter(Boolean).join(" ").trim();
      const admissionNo = acc.accountId?.split("::")[1] || "-";
      const primaryGuardian = guardians[0] || "-";
      const secondaryGuardian = guardians[1] || "-";
      const className = acc.extra?.standard || "-";
      const address = acc.address || "-";
      const role = acc.role || "STUDENT";
      const journeys = item.journeyNames || [];

      return {
        id: acc.accountId,
        avatar: renderAvatar(acc.avatar, name),
        admissionNo,
        name,
        primaryGuardian,
        secondaryGuardian,
        className,
        address,
        role,
        journeys,
      };
    });
  }, [accountData]);

  // ✅ Filter by role
  const filteredRows = useMemo(() => {
    if (filterRole === "All") return rows;
    return rows.filter((r) => r.role?.toUpperCase() === filterRole.toUpperCase());
  }, [rows, filterRole]);

  // ✅ Dispatch thunks on mount (if needed)
  useEffect(() => {
    dispatch(fetchApiData());
    setTimeout(() => {
      dispatch(fetchAccountGetData());
    }, 2000);
  }, [dispatch]);

  // ✅ Table columns config
  const columns = [
    { Header: "Avatar", accessor: "avatar", align: "left" },
    { Header: "Admission No.", accessor: "admissionNo", align: "left" },
    {
      Header: "Name",
      accessor: "name",
      align: "left",
      Cell: ({ row }) => (
        <MDTypography
          variant="button"
          fontWeight="medium"
          // color="warning"
          sx={{ cursor: "pointer",color:'#1398DC' }}
          onClick={() => setSelectedAccount(row.original)}
        >
          {row.original.name}
        </MDTypography>
      ),
    },
    { Header: "Primary Guardian", accessor: "primaryGuardian", align: "left" },
    { Header: "Secondary Guardian", accessor: "secondaryGuardian", align: "left" },
    { Header: "Class", accessor: "className", align: "left" },
    { Header: "Address", accessor: "address", align: "left" },
  ];

  return {
    columns,
    rows: filteredRows,
    orgName,
    loading,
    selectedAccount,
    setSelectedAccount,
    filterRole,
    setFilterRole,
  };
}